import React from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import useStyles from '../../assets/styles/style';
import TaskUploadHeading from '../../components/uploadTask/taskUploadHeading';
import UploadTask from '../../components/uploadTask/uploadTask';
import JsonToExcel from '../../components/uploadTask/JsonToExcel';
import UploadQuestionHeading from './UploadQuestionHeading';

const UploadQuestionsMain = () => {
  const classes = useStyles(); 
  const isJson = window.location.href.includes('json');
  return (
    <div className={classes.formMainContainer}>
      <Box className={classes.formMainHeadingBox}>
        <UploadQuestionHeading />
      </Box>
      <Box component="main" className={classes.formMainBox}>
        <Paper className={classes.formMainpaper}>
          {isJson ? <JsonToExcel/> : <UploadTask />}
        </Paper>
      </Box>
    </div>
  )
}

export default UploadQuestionsMain